import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Goalspoint() {
  return (
    <section
      className="goals_point p-100 text_white bg_green_color_left"
      style={{ background: "#000" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="goals_img">
              <StaticImage
                src="../../../images/case-studies/point2-design/goals_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={790}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h1>
              Project <span style={{ color: "#E8E751" }}>Goals</span>
            </h1>
            <p>
              The primary goal for the development of Point 2 Design was to
              provide an intuitive and efficient platform for celebrities to
              manage their orders seamlessly. This goal is based on the
              objective of digital signature integration with their orders,
              replacing traditional paper-based processes. Moreover, automating
              the order management process while reducing manual intervention
              and potential errors.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Goalspoint;
